import { parseInstant, parseInstantN } from '@rad/utility/parsers';
import { formatCurrency } from '@rad/utility/formatting';
import { getJson, postJson, withMap, withValidate, withOptional, withDone, } from '@rad/utility/http';
const mapPayment = (x) => (Object.assign(Object.assign({}, x), { 'occurred': parseInstant(x.occurred), 'amount': [x.amount, x.currency] }));
const mapEntitlement = (x) => (Object.assign(Object.assign({}, x), { 'effective': parseInstant(x.effective), 'expires': parseInstantN(x.expires) }));
const mapPlan = (x) => ({
    'monthly': (Object.assign(Object.assign({}, x), { 'price': formatCurrency([x.amount, x.currency]), 'title': 'Monthly', 'period': '/month', 'saveCopy': '', 'tagline': 'Lower commitment — change anytime.', 'blurb': 'Lower commitment — change anytime.', 'isBestValue': false, 'renewalLabel': 'every month', 'cadence': 'per month' })),
    'yearly': (Object.assign(Object.assign({}, x), { 'price': formatCurrency([x.amount, x.currency]), 'title': 'Annual', 'period': '/year', 'saveCopy': '2 months free', 'tagline': 'Best value — two months free vs. monthly.', 'blurb': 'Best value — two months free vs. monthly.', 'isBestValue': true, 'renewalLabel': 'every year', 'cadence': 'per year' }))
}[x.name]);
const mapSubscription = (x) => (Object.assign(Object.assign({}, x), { 'plan': mapPlan(x.plan) }));
const PLANS = '/api/plans';
const PAYMENTS = '/api/payments';
const SUBSCRIPTIONS = '/api/subscriptions';
export const getPaymentConfig = getJson(`${PAYMENTS}/config`);
export const savePaymentMethod = (x) => withDone(withValidate(postJson(`${PAYMENTS}/method`, x)))();
export const getPlans = withMap(getJson(`${PLANS}`), (xs) => xs.map(mapPlan));
export const createSubscription = (plan, method) => withDone(withValidate(withMap(postJson(`${SUBSCRIPTIONS}`, {
    'plan': plan.name,
    'method_id': method.id,
}), (x) => ({
    'context': x.context,
    'entitlement': mapEntitlement(x.entitlement),
    'subscription': mapSubscription(x.subscription),
}))))();
export const getEntitlement = withOptional(withMap(getJson(`${SUBSCRIPTIONS}/active`), mapEntitlement));
export const getSubscription = withOptional(withMap(getJson(`${SUBSCRIPTIONS}/current`), mapSubscription));
export const cancelSubscription = (subscription) => withDone(withMap(postJson(`${SUBSCRIPTIONS}/${subscription.id}/cancel`), mapSubscription))();
export const updateSubscriptionPlan = (subscription, plan) => withDone(withValidate(withMap(postJson(`${SUBSCRIPTIONS}/${subscription.id}/plan`, {
    'plan': plan.name,
}), mapSubscription)))();
export const updateSubscriptionMethod = (subscription, method) => withDone(withValidate(withMap(postJson(`${SUBSCRIPTIONS}/${subscription.id}/method`, {
    'method_id': method.id,
}), mapSubscription)))();
export const getPayments = withMap(getJson(`${PAYMENTS}`), (xs) => xs.map(mapPayment));
